import { isObject } from 'util';

/**
 * 格式化 url
 * @params url  需要格式化的url
 * @params context url参数中需要的上下文对象
 * @params data url参数中需要的数据对象
 * @params params 按钮配置的params
 * @params defaultParams 默认的追加到url的参数
 */

export function formatUrl(
    url,
    queryUrl,
    cmpContext,
    data,
    params,
    defaultParams
) {
    if (!url) {
        return '';
    }
    //去除url中的空格
    url = url.replace(/\s/gi, '');

    let tempData = {};

    if (Array.isArray(data) && data.length > 0) {
        //
        tempData = data[0];
        let newData = {
            id: tempData['_id']
        };
        newData.ids = data
            .map(row => {
                return row['_id'];
            })
            .join(',');

        tempData = Object.assign({}, newData, tempData);
    } else {
        tempData = data;
    }

    let allP = {
        queryUrl,
        cmpContext,
        context: cmpContext,
        data: tempData,
        params
    };

    if (url.indexOf('{app}') >= 0) {
        url = url.replace('{app}', BSGlobal.application);
    }

    for (let key in allP) {
        if (url.indexOf('{' + key + '.') >= 0) {
            for (let keyItem in allP[key]) {
                const reg = new RegExp('{' + key + '.' + keyItem + '}', 'g');
                url = url.replace(reg, allP[key][keyItem]);
            }
        }
    }

    let allParams = Object.assign({}, queryUrl, cmpContext, tempData, params);

    for (let key in allParams) {
        url = url.replace('{' + key + '}', allParams[key]);
    }

    //默认将defaultParam追加的url后面，目前没有处理配置的占位符与defaultParams的重复情况
    //以后有需求再处理
    let defaultParamStr = '';
    for (let param in defaultParams) {
        defaultParamStr += `${param}=${defaultParams[param]}&`;
    }
    if (defaultParamStr) {
        const infix = /\?.*=/g.test(url) ? '&' : '?';
        url =
            url + infix + defaultParamStr.slice(0, defaultParamStr.length - 1);
    }

    return url;
}

export function removeParam(key, sourceURL) {
    const regxStr = `&${key}(=[^&]*)?|^${key}(=[^&]*)?&?`;
    const regx = new RegExp(regxStr, 'g');
    return sourceURL.replace(regx, '');
}

export function getButtonQueryBodyParams(params, dataArr, queryUrl) {
    let rBody = {};
    let ids =
        toString.call(dataArr) == '[object Array]'
            ? dataArr
                  .map(row => {
                      return toString.call(row['_id']) === '[object Object]'
                          ? row['_id']['value']
                          : row['_id'];
                  })
                  .join(',')
            : '';
    let data = toString.call(dataArr) == '[object Array]' ? dataArr[0] : {};
    for (let key in params) {
        let arr = key.split('queryBody_');
        if (arr.length == 2 && key.startsWith('queryBody_')) {
            let value = params[key];
            let node = params[key]
                .replace('{', '')
                .replace('}', '')
                .split('.');
            //目前只是支持 {data.ids} 这种格式的占位符， 不支持嵌套的占位
            if (node.length > 1) {
                if (node[0] == 'datas') {
                    let value = '';
                    dataArr.forEach(item => {
                        let val = item[node[1]] ? item[node[1]] : '';
                        if (value) {
                            value += ',' + val;
                        } else {
                            value += val;
                        }
                    });
                    rBody[arr[1]] = value;
                } else {
                    if (node[1] == 'ids') {
                        rBody[arr[1]] = ids;
                    } else {
                        rBody[arr[1]] = data[node[1]] || value;
                    }

                    if (queryUrl && node[0] === 'queryUrl') {
                        rBody[node[1]] = queryUrl[node[1]];
                    }
                }
            } else {
                if (arr[1] == 'ids') {
                    rBody[arr[1]] = ids;
                } else {
                    rBody[arr[1]] = node[0] || value;
                }
            }
        }
    }
    return rBody;
}

export function keepHttpsProtocolSame(url) {
    if (
        url.startsWith('http') &&
        !url.startsWith('https') &&
        location.protocol === 'https:'
    ) {
        return url.replace('http://', 'https://');
    }
    return url;
}

export function androidChangeTime_stampToSearch(url) {
    if (typeof url != 'undefined') {
        let timeIndex = url.indexOf('time_stamp');
        let stamp = parseInt(
            new Date()
                .getTime()
                .toString()
                .substr(0, 10)
        );
        if (timeIndex > -1) {
            let time_stamp = url.indexOf('time_stamp')
                ? url.substring(timeIndex, url.indexOf('&', timeIndex))
                : 'time_stamp=' + stamp;
            url = url.replace(time_stamp, 'time_stamp=' + stamp);
        }
        return url;
    }
    return '';
}

/**
    *获取url与参数拼接符
    @ params url String
    @ return  String &/?

*/
export function getConnectSymbol(url) {
    return url.indexOf('?') >= 0 ? '&' : '?';
}

/**
    *拼接get请求params到url上
    @ params url String
    @ return  &string=''

*/
//序列化url
export function serializeUrl(obj) {
    let result = [];
    for (let k in obj) {
        if (Array.isArray(obj[k]) || isObject(obj[k])) {
            obj[k] = JSON.stringify(obj[k]);
        }
        result.push(encodeURIComponent(k) + '=' + encodeURIComponent(obj[k]));
    }
    return result.join('&');
}



// WEBPACK FOOTER //
// ./src/components/util/url.js